import { IntercomProvider } from 'react-use-intercom'

const IntercomProviderAdapter = ({ children, appId }) => {
  return <IntercomProvider appId={appId}>{children}</IntercomProvider>
}

export default IntercomProviderAdapter
